/* global process */
import format from 'date-fns/format'
import { de, frCH, enUS, hr, srLatn, sl, bs } from 'date-fns/locale'
import config from '@config'
import scrollIntoView from 'scroll-into-view'

const locales = { de, fr: frCH, en: enUS, hr, sr: srLatn, sl, bs }
/**
 * Determines if development.
 *
 * @return     {boolean}  True if development, False otherwise.
 */
export const isDevelopment = () => process.env.NODE_ENV !== 'production'
/**
 * Determines if production.
 *
 * @return     {boolean}  True if production, False otherwise.
 */
export const isProduction = () => process.env.NODE_ENV === 'production'

/**
 * Determines if production.
 *
 * @return     {boolean}  True if production, False otherwise.
 */
export const formatDate = (date, fmt) =>
  format(date, fmt, { locale: locales[config.get('local.locale') || 'de'] })

export const track = (evt, payload = {}) => {
  if (window.tracker && window.tracker.push) {
    window.tracker.push(evt, payload)
  } else {
    console.info('[tracker.push]', evt, payload)
  }
}

export const scrollTo = (elId = 'appointments-footer', settings = { align: { top: 1 } }) => {
  scrollIntoView(document.getElementById(elId), settings)
}
